// Links players share (invite to a room). Inside the Android / iOS apps the
// page's own origin is "https://localhost" (Capacitor), which means nothing to a
// friend: the link must point to the public website, which opens /join/… in a
// browser. REACT_APP_SITE_URL can change it at build time.
import { Capacitor } from "@capacitor/core";

export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://ramionline.com").replace(/\/$/, "");

const origin = () => (Capacitor.isNativePlatform() ? SITE_URL : window.location.origin);

export const inviteUrl = (roomId) => `${origin()}/join/${roomId}`;

// Invite links are offered on the website only (owner's choice): in the apps,
// friends join with the room code shown in the waiting room.
export const INVITE_LINKS = !Capacitor.isNativePlatform();
